export default function ReactionLog({ log }) {
  return (
    <div className="bg-white border rounded-lg p-3 h-40 overflow-y-auto text-sm text-gray-700">
      {log.length === 0 ? (
        <div className="italic text-gray-400">No steps yet...</div>
      ) : (
        log.map((l, i) => <div key={i}>• {l}</div>)
      )}
    </div>
  );
}
